import { useGetNotifications } from "../operations/queries/getNotifications";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { useDismissNotifications } from "../operations/mutations/dismissNotifications";
import NotificationsList from "../components/NotificationsList";

const NotificationsListContainer = () => {
  const { user } = useCurrentUser();
  const { data: notificationsData, refetch: refetchNotifications } = useGetNotifications(user?.id ?? "");
  const { mutate: dismissNotifications } = useDismissNotifications();

  const handleDismissNotifications = (ids: string[]) => {
    dismissNotifications({
      variables: {
        notificationIds: ids,
      },
    }).then(() => {
      refetchNotifications && refetchNotifications();
    });
  };

  return (
    <NotificationsList
      notifications={notificationsData && notificationsData.notifications}
      onDismissNotifications={handleDismissNotifications}
    ></NotificationsList>
  );
};

export default NotificationsListContainer;
